import * as React from 'react';
import { FC } from 'react';
import {
    useTranslate,
    NumberField,
    DateField,
    Record,
    // FunctionField,
} from 'react-admin'
import {
    makeStyles,
    createStyles,
    Theme,
    Typography,
    Grid,
} from '@material-ui/core';
import { dateLocales, defaultDateOptions } from '../utils/formatters';


interface AsideProps {
    record?: Record;
    basePath?: string;
}


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            minWidth: '200px'
        },
        container: {
            flexGrow: 1,
        },
        asideTitle: {
            fontWeight: 'bold'
        }
    })
)

const Aside: FC<AsideProps> = ({ record, basePath }) => {
    const classes = useStyles()
    const translate = useTranslate()

    return <div className={classes.root}>
        <Typography variant="h6" gutterBottom>
            {translate(
                'resources.common.fieldGroups.info'
            )}
        </Typography>
        <Grid container className={classes.container} spacing={2}>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.asideTitle}>{translate("resources.common.fields.id")}</Typography>
                <NumberField source="id" />
            </Grid>
            <Grid item xs={12} lg={6}>
                <Typography className={classes.asideTitle}>{translate("resources.common.fields.created_at")}</Typography>
                <DateField source="created_at" locales={dateLocales} options={defaultDateOptions} showTime />
            </Grid>
            <Grid item xs={12} lg={6}>
                <Typography className={classes.asideTitle}>{translate("resources.common.fields.updated_at")}</Typography>
                <DateField source="updated_at" locales={dateLocales} options={defaultDateOptions} showTime />
            </Grid>
        </Grid>
    </div>
}


export default Aside